export interface UserProfile {
  skymiles_number: string;
  skymiles_tier?: string;
  medallion_tier?: string;
  email: string;
  encrypted_email: string;
  email_domain: string;
  available_miles: string | number;
  amex_card_type?: string;
  cobrand_type?: string;
  company_name?: string;
}

export interface UserAttributes {
  is_logged_in: string;
  login_method?: string;
  login_state?: string;
}

export interface User {
  attributes: UserAttributes;
  profile?: UserProfile;
}

export interface PageInfo {
  legacy_page_name: string;
  page_name: string;
  page_url: string;
  page_type: string;
  previous_page_name: string | null;
  previous_page_url: string | null;
  section: string;
  sub_section: string;
  country: string;
  language: string;
  sys_env: string;
  page_load_time: number;
  flow_type?: string;
  subpage_name?: string;
  subpage_type?: string;
}

export interface Page {
  info: PageInfo;
}

export interface BusinessTraveler {
  company_name: string;
  company_size: string;
  company_type: string;
  role: string;
}

export interface Promotions {
  code: string;
  details?: string;
  type: string;
}

export interface DataLayerAnalytics {
  event_detail?: string;
  event: string;
  page?: Page;
  user: User;
  error?: Error[];
  click?: Click;
  site_assets?: AnalyticsSiteAssets[];
  booking?: Booking;
  business_traveler?: BusinessTraveler[];
  promotions?: Promotions[];
  sort?: SortData;
  filter?: FilterData[];
}

export interface Booking {
  skymiles: SkymilesPurchase[];
}

export interface SkymilesPurchase {
  product_name: string;
  recipient?: string;
  miles?: number;
  bonus_miles?: number;
}

export interface AnalyticsSiteAssets {
  id: string;
  type: string;
  position?: string;
  name: string;
  sub_type: string;
  source?: string;
  image_url?: string;
  membership_tier?: string;
  miles?: number;
  category?: string;
}

export interface Click {
  name: string;
  modal_name?: string;
  type: string;
  page_section: string;
  page_subsection?: string;
  action: string;
}
export interface Error {
  type: string;
  code: string;
  text?: string;
  message?: string;
  destination_url?: string;
  event_detail?: string;
  event?: string;
}

export interface PreviousPageDetails {
  url: string;
  name: string;
}

export interface SortData {
  applied: string;
}

export interface FilterData {
  category: string;
  value: string;
}

export interface SortFilterAnalytics {
  sort: SortData;
  filter: FilterData[];
}
